import { TimeEvent } from '../models';

/**
 * Liefert die Event-Bezeichnungen in der aktuell geladenen Sprache.
 * Die $localize-Auswertung erfolgt bei jedem Aufruf zur Laufzeit (nach loadTranslations), damit
 * die geladenen Übersetzungen greifen und der Quelltext nicht beim Modul-Import einfriert.
 */
export function getEventConfig(): { [index: string]: string } {
  return {
    [TimeEvent.WorkStart]: $localize`Arbeitszeit starten`,
    [TimeEvent.DriveStart]: $localize`Fahren`,
    [TimeEvent.CarEquipStart]: $localize`Fahrzeug rüsten`,
    [TimeEvent.CarEquipEnd]: $localize`Fahrzeug rüsten beenden`,
    [TimeEvent.CarLogout]: $localize`Vom Fahrzeug abmelden`,
    [TimeEvent.BufferstockStart]: $localize`Bufferstock rüsten`,
    [TimeEvent.MachineStart]: $localize`Automat bearbeiten`,
    [TimeEvent.CustomerStart]: $localize`Kundenzeit starten`,
    [TimeEvent.CustomerEnd]: $localize`Kundenzeit beenden`,
    [TimeEvent.IndividualStart]: $localize`Individuelle Zeit starten`,
    [TimeEvent.IndividualEnd]: $localize`Individuelle Zeit beenden`,
    [TimeEvent.Logout]: $localize`Arbeitszeit beenden`,
  };
}
